import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import { Utils } from './utils/utils';
import Vtip from 'vtip'
import 'vtip/lib/index.min.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
/* 引入并注册滚动插件 */
import Vuescroll from 'vuescroll';
Vue.use(Vuescroll, { name: 'Vuescroll' });
Vue.prototype.$vuescrollConfig = { bar: { background: '#999' } };
Vue.prototype.$bus = new Vue()
    // 全局引入elementui
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/elementCss/theme/index.css';

//引入按钮组件
import CustomButton from '@/components/CustomButton.vue'
Vue.component('CustomButton', CustomButton);

/* 引入iconfont图标 */
import '@/assets/font/iconfont.css';

// 全局注册elementui
Vue.use(ElementUI, { zIndex: 3000 });
// 注册指令使用
Vue.use(Vtip.directive);

// 挂载MD5到原型上
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
/* 引入、注册 自定义卡片组件(Card) */
import CardBox from '@/components/Card.vue';
Vue.component('Card', CardBox);
// 
Vue.prototype.$bigNumber = Utils.bigNumber;
Vue.prototype.$toFixed = Utils.toFixed;
/* 引入store */
import store from './store/index';
Vue.prototype.$store = store;

/* 注册埋点工具类 */
import TrackTool from '@/utils/trackTool';
window.$trackTool = new TrackTool({ source: 'his_system' })

/* 获取环境并设置基础请求地址、资源加载、社保代理基础路径 */
const environment = process.env.NODE_ENV;
Vue.prototype.$filePath = environment === 'development' ? '/fileUrl' : process.env.VUE_APP_BASEURL; // 资源加载路径
Vue.prototype.$baseUrl = environment === 'development' ? '/baseUrl' : '/api'; // 接口调用路径
Vue.prototype.$baseXlUrl = '/xl'; // 接口调用路径
Vue.prototype.$shebaoUrl = environment === 'development' ? '/shebaoUrl' : process.env.VUE_APP_MEDICAL_URL; // 社保调用路径
Vue.prototype.$voiceUrl = environment === 'development' ? '/voiceUrl' : process.env.VUE_APP_VOICE_URL; // 语音调用路径
Vue.prototype.$printUrl = environment === 'development' ? '/printUrl' : process.env.VUE_APP_PRINT_URL; // 打印调用路径



/* VUE实例 挂载 全局通用数据 */
Vue.prototype.$drugType = ['中药饮片', '中药颗粒'];
Vue.prototype.$sourceOptions = ['复诊', '导医推荐', '亲友推荐', '线上活动', '线下活动', '网络推广', '客服推荐', '公众号预约'];
Vue.prototype.$handlingOptions = ['先熬半小时', '先熬1小时', '后下', '包煎', '冲服', '另包', '烊化', '另煎', '捣碎', '先炒', '打粉'];
Vue.prototype.$speciesOptions = [
    '手太阴肺经穴', '手阳明大肠经穴', '足阳明胃经穴', '足太阴脾经穴', '手少阴心经穴', '手太阳小肠经穴',
    '足太阳膀胱经穴', '足少阴肾经穴', '手厥阴心包经经穴', '手少阳三焦经穴', '足少阳胆经穴', '足厥阴肝经穴',
    '任脉穴', '督脉穴', '头颈部穴', '胸腹部穴', '背部穴', '上肢部穴', '下肢部穴', '阿是穴', '脐穴'
];
Vue.prototype.$processOptions = ['熬药', '制膏', '蜜丸', '水丸', '粗粉', '细粉'];
let mlNumber = [];
for (let volume = 50; volume <= 300; volume += 10) {
    mlNumber.push({ value: volume, label: volume + 'ml' });
}
Vue.prototype.$mlNumber = mlNumber;
Vue.prototype.$userType = [{ label: '医生', value: '0' }, { label: '医助', value: '1' }, { label: '员工', value: '2' }, { label: '其他', value: '3' }, { label: '理疗师', value: '4' }, { label: '药师', value: '5' }, { label: '护士', value: '6' }];
Vue.prototype.$doctorTitlesOptions = ['主任医师', '副主任医师', '主任中医师', '副主任中医师', '教授', '副教授', '执业医师', '主治医师','中西医结合医师', '康复理疗师', '助理医师'];
Vue.prototype.$otherDeliveryWay = ['圆通', '申通', '中通', '韵达', '顺丰同城', '邮政', '达达', '京东', '顺丰急送'];

/* 全局注册 时间段数组 */
import timeRange from '@/utils/timeRange';
Vue.prototype.$timeRange = timeRange;

/* 全局注册 年龄计算函数 */
import computeAge from '@/utils/computeAge';
Vue.prototype.$computeAge = computeAge;

/* 全局注册 生日计算函数 */
import computeBirthday from '@/utils/computeBirthday';
Vue.prototype.$computeBirthday = computeBirthday;

/* 全局注册 计算时间区间所有月份函数 */
import computeMonths from '@/utils/computeMonths';
Vue.prototype.$computeMonths = computeMonths;

/* 全局注册 计算时间区间所有日期函数 */
import computeDates from '@/utils/computeDates';
Vue.prototype.$computeDates = computeDates;

/* 全局注册 分钟计算时间函数 */
const computeTime = function(value) {
    return (parseInt(value / 60) < 10 ? ('0' + parseInt(value / 60)) : parseInt(value / 60)) + ':' + ((value % 60) < 10 ? ('0' + (value % 60)) : (value % 60));
}
Vue.filter('$computeTime', computeTime);
Vue.prototype.$computeTime = computeTime;

/* 全局注册 秒钟计算时间函数 */
const computeTime1 = function(value) {
    return (parseInt(value / 60 / 60) < 10 ? ('0' + parseInt(value / 60 / 60)) : parseInt(value / 60 / 60)) + ':' + ((value / 60 % 60) < 10 ? ('0' + (value / 60 % 60)) : (value / 60 % 60));
}
Vue.filter('$computeTime1', computeTime1);
Vue.prototype.$computeTime1 = computeTime1;

/* 全局注册 报表月份查询快捷选项 */
const shortcuts = [{
        text: '本月',
        onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()]);
        }
    },
    {
        text: '最近三个月',
        onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 2);
            picker.$emit('pick', [start, end]);
        }
    },
    {
        text: '最近六个月',
        onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 5);
            picker.$emit('pick', [start, end]);
        }
    },
    {
        text: '今年一月至今',
        onClick(picker) {
            const end = new Date();
            const start = new Date(new Date().getFullYear(), 0);
            picker.$emit('pick', [start, end]);
        }
    }
]
Vue.prototype.$shortcuts = shortcuts;

/* 全局注册 弹框关闭/还原表单函数 */
function handleClose(done, form, form1) {
    done();
    if (form) this.$refs[form].resetFields();
    if (form1 && this.editForm.type == 0) this.$refs[form1].resetFields();
}
Vue.prototype.$handleClose = handleClose;

/* 全局注册 页面刷新函数 */
function refresh(func, isSearch) {
    this.loading = true;
    if (isSearch == true) { // 如果查询表单有数据，将currentPage设置为0，再拉取列表数据
        this.currentPage = 1;
        funcs();
    } else funcs(); // 否则拉取列表数据
    function funcs() {
        if ((func instanceof Array) == false) func();
        else func.forEach(funcItem => {
            funcItem();
        });
    }
}
Vue.prototype.$refresh = refresh;

/* 全局注册 取消保存函数 */
function cancel(dialog, form, form1) {
    this[dialog] = false;
    if (form) this.$refs[form].resetFields();
    if (form1 && this.editForm.type == 0) this.$refs[form1].resetFields();
}
Vue.prototype.$cancel = cancel;

/* 全局注册 全选及取消全选 */
function handleSelectionChange(val, flag) {
    this.multipleSelection = val;
}
Vue.prototype.$handleSelectionChange = handleSelectionChange;

/* 全局注册 重置查询表单函数 */
function reset(func, searchForm) {
    this.searchForm = searchForm;
    this.$refresh(func);
}
Vue.prototype.$reset = reset;

/* 全局注册 当前页改变函数 */
function handleCurrentChange(page, func) {
    this.currentPage = page;
    this.$refresh(func);
}
Vue.prototype.$handleCurrentChange = handleCurrentChange;

/* 全局注册 报表统计-导出报表函数 */
function exportSummary(form, url, fileName) {
    axios({
        method: "post",
        url: url,
        data: { dates: form.dates, deptIds: form.deptIds },
        responseType: "blob"
    }).then(res => {
        if (res.data.size > 0) {
            const link = document.createElement('a');
            let objectUrl = window.URL.createObjectURL(res.data); // 创建URL
            link.href = objectUrl;
            link.download = fileName + '.xlsx'; // 自定义文件名
            link.click(); // 下载文件
            URL.revokeObjectURL(objectUrl); // 释放内存
        } else this.$message.warning('表格没有数据，无法下载！');
    });
}
Vue.prototype.$exportSummary = exportSummary;

/* 全局注册 报表统计-设置月份函数 */
function setDates(val, func) {
    this.$computeMonths(val);
    this.monthNum = this.searchForm.dates.length;
    this.$refresh(func);
}
Vue.prototype.$setDates = setDates;

/* 全局注册 报表统计-默认医馆、月份设置 */
function setCurMonth(func) {
    let date = new Date;
    let month = (date.getMonth() + 1) > 10 ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1));
    let year = date.getFullYear();
    let yearMonth = year + '-' + month + '-01';
    this.searchForm = { deptIds: [this.$session.get('deptId')], dates: [yearMonth], date: [yearMonth, yearMonth] };
    this.$refresh(func);
}
Vue.prototype.$setCurMonth = setCurMonth;

/* 全局注册 馆内在职医生获取 */
import { doctorList } from "@/api/doctor";

function getDoctorOptions(params) {
    const paramsStr = JSON.stringify(this.$store.state.doctorParams);
    let _this = this;
    if (JSON.stringify(params) == paramsStr) {
        if (this.$store.state.doctorOptions.length > 0) this.doctorOptions = this.$store.state.doctorOptions;
        else getDoctorList(params, _this);
    } else {
        this.$store.state.doctorParams = params;
        getDoctorList(params, _this);
    }

    async function getDoctorList(params, _this) {
        let { rows, code } = await doctorList(params);
        if (code == 200) {
            _this.doctorOptions = [];
            rows.forEach(item => {
                let { doctorName, doctorId, phone, userCode, doctorCode, isExam, assistantName, doctorTitle,sex } = item;
                _this.doctorOptions.push({ label: doctorName, value: doctorId, phone, userCode, doctorCode, isExam, assistantName, doctorId, doctorName, doctorTitle,sex });
            });
            _this.$store.state.doctorOptions = _this.doctorOptions;
        }
    }
}
Vue.prototype.$getDoctorOptions = getDoctorOptions;

/* 全局注册 本地存储函数 */
import session from '@/utils/session'; // 获取本地存储
Vue.prototype.$session = session;

Vue.config.productionTip = false;

/* 全局注册 网诊长链接 */
import wsOfWebChat from './utils/wsOfWebChat';
Vue.prototype.$initWebSocketWebChat = wsOfWebChat.initWebSocketWebChat;
Vue.prototype.$sendText = wsOfWebChat.sendText;
Vue.prototype.$getChatList = wsOfWebChat.getChatList;

/* 全局注册 拍单长链接 */
import initWebSocketTakeOrder from './utils/wsOfOnlineTake';
Vue.prototype.$initWebSocketTakeOrder = initWebSocketTakeOrder;

/* 全局注册 医保工具函数 */
import { initYB, settlement, cancelSettlement } from "./utils/yibaoTools";
Vue.prototype.$initYB = initYB;
Vue.prototype.$settlement = settlement;
Vue.prototype.$cancelSettlement = cancelSettlement;

/* 引入临时数据 */
import temporaryList from './utils/temporary';
Vue.prototype.$temporaryList = temporaryList;


// 全局注册moment
import moment from 'moment';
Vue.prototype.$moment = moment;
//全局注册lodash
import lodash from 'lodash';
Vue.prototype.$lodash = lodash;
var _ = require('lodash');
//全局注册指令
import { loadMore } from '@/directive/index.js'
Vue.use(loadMore)

// Vue.config.errorHandler = function (err, vm, info) {
//     console.log('Error111:', err)
//     console.log('Vue instance111:', vm)
//     console.log('Info11111:', info)
// }

if (window.__POWERED_BY_QIANKUN__) {
    __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
}

let instance = null;

const originFn = document.body.appendChild.bind(document.body)

function redirectPopup(container) {
    // 子应用中需要挂载到子应用的弹窗className。样式class白名单，用子应用的样式。
    const whiteList = ['el-select-dropdown', 'el-popper', 'el-popover', 'el-dialog__wrapper', 'el-drawer__wrapper', 'el-tooltip__popper', 'el-message-box__wrapper', 'el-message', 'el-loading-mask', 'el-notification']
  
    // 保存原有document.body.appendChild方法
    const originFn = document.body.appendChild.bind(document.body)
  
    // 重写appendChild方法
    document.body.appendChild = (dom) => {
      // 根据标记，来区分是否用新的挂载方式
      let count = 0
      whiteList.forEach((x) => {
        if (dom.className.includes(x)) count++
      })
      if (count > 0 && container.container) {
        // 有弹出框的时候，挂载的元素挂载到子应用上，而不是主应用的body上
        container.container.querySelector('#his_system').appendChild(dom)
      } else {
        originFn(dom)
      }
    }
  }

function render(props = {}) {
    const { container } = props;

    redirectPopup(props)

    instance = new Vue({ router, render: h => h(App) }).$mount(container ? container.querySelector('#his_system') : '#his_system');
}

if (!window.__POWERED_BY_QIANKUN__) {
    render();
}
  
export async function bootstrap(props) {
    console.log('[vue] vue app bootstraped');
}
  
export async function mount(props) {
    console.log('[vue] props from main framework', props);
    render(props);
}
  
export async function unmount() {
    instance.$destroy();
    instance.$el.innerHTML = '';
    instance = null;
    document.body.appendChild = originFn
}

Date.prototype.Format = function(fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
};